import classNames from "classnames";
import css from "./index.module.scss";
import { UseStreamTextProps, useStreamText } from "./useStreamText";
import React, { useEffect, useImperativeHandle } from "react";

type StreamTextProps = UseStreamTextProps & {
  className?: string;
};

export type StreamTextFunction = {
  stop: (isManual: boolean) => void;
};

export const StreamText = React.forwardRef<StreamTextFunction, StreamTextProps>((props, ref) => {
  const { className, isStreamStopped, ..._props } = props;

  const { streaming, streamContent, streamList, stop } = useStreamText(_props);

  // 暴露子组件方法
  useImperativeHandle(ref, () => ({
    stop,
  }));

  useEffect(() => {
    if (props.isStreamStopped) {
      stop(false);
    }
  }, [props.isStreamStopped]);

  return (
    <div className={classNames(className)} data-testid="StreamText">
      {/* <div style={{ color: "red" }} onClick={refresh}>
        refresh
      </div> */}

      {_props.disabled || !streaming || isStreamStopped
        ? streamContent
        : streamList.map((value, index) => (
            <span className={css["value"]} key={`${value}${index}`}>
              {value}{" "}
            </span>
          ))}
    </div>
  );
});
